module.exports = __webpack_public_path__ + "static/media/ic_covid_b_2_fisdom.ed8d8512.svg";